module.exports = __webpack_public_path__ + "img/question-mark-white.cf154750.svg";